import BaseService from '@src/services/BaseService'

class UsersService extends BaseService {
    constructor() {
        super('admin/users', false)
    }
}

export default new UsersService()
